import Vue from "vue";
import Router from "vue-router";
import layouts from "@/layout.js";
import store from "@/store";
import nProgress from "nprogress";
import "nprogress/nprogress.css";

// Modules
import customer_service from "./modules/customer_service";
import finances from "./modules/finances";
import status from "./modules/status";
import iso from "./modules/iso";
import legal from "./modules/legal";
import legalMTR from ".././views/modules/legal/indexLegalCompR/legalMTR";
import legalTB from ".././views/modules/legal/indexLegalCompR/legalTenn";
import legalRB from ".././views/modules/legal/indexLegalCompR/legalRb";
import marketing from "./modules/marketing";
import projects from "./modules/projects";
import purchases from "./modules/purchases";
import administration from "./modules/administration";
import sales from "./modules/sales";
import technical_support from "./modules/technical_support";
import workshop from "./modules/workshop";
import call_center from "./modules/call_center";
import automatic_processes from "./modules/automatic_processes";
import kpi from "./modules/kpi";
import authorizer from "./modules/authorizer";
import development from "./modules/development";
import policies from "./modules/politicas";
import infrastructure from "./modules/infrastructure";
import Audit_transactions from "./modules/audit_transactions";
import Agenda_maintencance from "./modules/agenda-maintenance";
import HistoryJobs from "./modules/historyjobs";
import Technology from "./modules/technology";
import vehicleview from "./modules/vehicleview";

// Apps
import activity_flow from "./apps/activity_flow";
import galleries from "./apps/galleries";
import employees from "./apps/employees";
import our_company from "./apps/our_company";
import calendar from "./apps/calendar";
import cmi from "./apps/cmi";
import validarSolicitud from "./apps/validate";
import internalRequests from "./apps/internal_request";

import Login from "../views/auth/Login";
import ForgotPassword from "../views/auth/ForgotPassword";
import NotFound from "../views/errors/NotFound";
import Error500 from "../views/errors/500.vue";
import AccessDenied from "../views/errors/AccessDenied.vue";
import Dashboard from "../views/Dashboard.vue";
import UserProfile from "../views/UserProfile.vue";
import DasboardCmi from "../views/apps/cmi/objetives/Dashboard.vue";
import BaseD from "../views/apps/cmi/objetives/BaseD.vue";
import manager from "./manager";
import { IsInRoles } from "@/utils";
import ceo from "./apps/ncfmovil";
import _Productivity from "../views/modules/Productivity/ProductivityManagement.vue";

Vue.use(Router);
const RedirectByDefult = "/";
const router = new Router({
  mode: "history",
  //base: '/sub-path/',
  routes: [
    // Modules
    customer_service,
    finances,
    status,
    iso,
    legal,
    legalMTR,
    legalTB,
    legalRB,
    marketing,
    projects,
    purchases,
    administration,
    sales,
    technical_support,
    workshop,
    call_center,
    automatic_processes,
    kpi,
    authorizer,
    development,
    policies,
    infrastructure,
    HistoryJobs,
    Technology,
    vehicleview,
    // Apps
    activity_flow,
    galleries,
    employees,
    our_company,
    calendar,
    cmi,
    validarSolicitud,
    ceo,
    internalRequests,
    Audit_transactions,
    Agenda_maintencance,
    // Others
    manager,
    {
      path: "/profile",
      name: "user-profile",
      component: UserProfile,
      meta: {
        auth: true,
        layout: layouts.navLeft
      }
    },
    {
      path: "/productivity",
      name: "productivity",
      component: _Productivity,
      meta: {
        title: "Productividad Gerencial",
        auth: true,
        layout: layouts.navLeft
      }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: BaseD,
      meta: {
        title: "Mis Objetivos",
        auth: true,
        layout: layouts.navLeft
      },
      children: [
        {
          path: "cmi",
          name: "dashboardcmi",
          component: DasboardCmi,
          meta: {
            title: "Dashboard",
            auth: true,
            layout: layouts.navLeft
          }
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        layout: layouts.contenOnly
      }
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: ForgotPassword,
      meta: {
        layout: layouts.contenOnly
      }
    },
    {
      path: "/logout",
      // eslint-disable-next-line no-unused-vars
      beforeEnter(to, from, next) {
        try {
          auth.logout();
          // no es necesario llamar next({ path: "/login" });
          // el stora action auth/logout ya hace el push al login.
        } catch (e) {
          console.error(e);
        }
      }
    },
    {
      path: "/access-denied",
      name: "access-denied",
      component: AccessDenied,
      meta: {
        layout: layouts.contenOnly
      }
    },
    {
      path: "*",
      alias: "/not-found",
      name: "not-found",
      component: NotFound,
      meta: {
        layout: layouts.contenOnly
      }
    },
    {
      path: "/error",
      name: "error",
      component: Error500,
      meta: {
        layout: layouts.contenOnly
      }
    },
    {
      path: "/example",
      name: "example",
      component: Dashboard,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["sales", "documents"]
      }
    }
  ]
});

const l = {
  contenOnly() {
    store.commit("setLayout", layouts.contenOnly);
  },
  navLeft() {
    store.commit("setLayout", layouts.navLeft);
  },
  navRight() {
    store.commit("setLayout", layouts.navRight);
  },
  navTop() {
    store.commit("setLayout", layouts.navTop);
  },
  navBottom() {
    store.commit("setLayout", layouts.navBottom);
  },
  set(layout) {
    store.commit("setLayout", layout);
  }
};

//insert here login logic
const auth = {
  loggedIn() {
    return store.getters["auth/isAuthenticated"];
  },
  async logout() {
    await store.dispatch("auth/logout");
  }
};

// eslint-disable-next-line no-unused-vars
router.beforeEach(async (to, from, next) => {
  if (to.path) {
    nProgress.start();
  }

  try {
    store.commit("setMainActiveMenu", to.matched[0].path);
  } catch (_) {
    //
  }

  let authrequired = false;
  const currentUser = store.state.user.user;

  if (to && to.meta && to.meta.auth) authrequired = true;

  if (to.meta.roles && !IsInRoles(to.meta.roles, currentUser.Roles)) {
    next({
      name: "access-denied"
    });
    return false;
  }

  if (to.meta.disable && to.meta.disable === true) {
    next({
      name: "access-denied"
    });
    return false;
  }

  if (authrequired) {
    if (auth.loggedIn()) {
      if (to.name === "login") {
        window.location.href = RedirectByDefult;
        return false;
      } else {
        next();
      }
    } else {
      if (to.name !== "login") {
        window.location.href = "/login";
        return false;
      }
      next();
    }
  } else {
    if (auth.loggedIn() && to.name === "login") {
      window.location.href = RedirectByDefult;
      return false;
    } else {
      next();
    }
  }

  if (to && to.meta && to.meta.layout) {
    l.set(to.meta.layout);
  }
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  nProgress.done();

  setTimeout(() => {
    store.commit("setSplashScreen", false);
  }, 500);
});

export default router;
